export const countryFlag = [
  { languageCode: 'RU', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-RU.svg` },
  { languageCode: 'PS', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-PS.svg` },
  { languageCode: 'AR', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-AR.svg` },
  { languageCode: 'EN', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-EN.svg` },
  { languageCode: 'PT', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-PT.svg` },
  { languageCode: 'DE', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-DE.svg` },
  { languageCode: 'DU', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-DU.svg` },
  { languageCode: 'FR', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-FRCA.svg` },
  { languageCode: 'ES', flag: `${process.env.REACT_APP_STATIC_IMAGE}/ES.png` },
  { languageCode: 'SR', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-SR.svg` },
  { languageCode: 'BS', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-BA.svg` },
  { languageCode: 'BG', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-BG.svg` },
  { languageCode: 'CN', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-CN.svg` },
  { languageCode: 'JA', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-JP.svg` },
  { languageCode: 'MS', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-MY.svg` },
  { languageCode: 'GR', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-GR.svg` },
  { languageCode: 'TR', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-TR.svg` },
  { languageCode: 'CZ', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-CZ.svg` },
  { languageCode: 'SK', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-SK.svg` },
  { languageCode: 'DA', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-DK.svg` },
  { languageCode: 'HI', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-IN.svg` },
  { languageCode: 'FI', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-FI.svg` },
  { languageCode: 'SW', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-SE.svg` },
  { languageCode: 'HU', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-HU.svg` },
  { languageCode: 'ID', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-ID.svg` },
  { languageCode: 'FA', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-IR.svg` },
  { languageCode: 'IT', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-IT.svg` },
  { languageCode: 'KO', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-KR.svg` },
  { languageCode: 'MT', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-MT.svg` },
  { languageCode: 'MU', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-MU.svg` },
  { languageCode: 'RO', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-RO.svg` },
  { languageCode: 'TH', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-TH.svg` },
  { languageCode: 'VI', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-VN.svg` },
  { languageCode: 'PL', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-PL.svg` },
  { languageCode: 'NO', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-NO.svg` },
  { languageCode: 'AU', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-AU.svg` },
  { languageCode: 'EN-CA', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-CA.svg` },
  { languageCode: 'EN-NZ', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-NZ.svg` },
  { languageCode: 'EN-SE', flag: `${process.env.REACT_APP_STATIC_IMAGE}/flag-SE.svg` }
]
